export function unSubscribeGameChannel(id: number, gameId: string) {
  console.log(`leave private-mini_app.${id}.games.${gameId}`);
  window.Echo.leaveChannel(`private-mini_app.${id}.games.${gameId}`);
}
